import Service from "@/helpers/factoryTourService";

export default {
  index(params) {
    return Service().get("blog", { params });
  },
  show(code) {
    return Service().get("blog/" + code);
  },
};
